/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import React from "react";

import { useFetchAdminTicket } from "./useFetchAdminTicket";

export const AdminTicketDashboard: React.FC = () => {
  const displayTickets = useFetchAdminTicket();
  return (
    <div css={styles.container}>
      <div css={styles.headerText}>チケット状況</div>

      <div css={styles.tableWrapper}>
        <table css={styles.table}>
          <thead>
            <tr css={styles.headerRow}>
              <th>チケットID</th>
              <th>チケット名</th>
              <th>購入数</th>
              <th>チケットもぎり数</th>
              <th>チケットもぎり率</th>
              <th>特典もぎり数</th>
              <th>特典もぎり率</th>
            </tr>
          </thead>

          <tbody>
            {displayTickets.map((t) => (
              <tr key={t.ticketId} css={styles.rowItem}>
                <td css={styles.rowText}>{t.ticketId}</td>
                <td style={{ fontWeight: "bold" }}>{t.name}</td>
                <td>{t.purchasedCount}</td>
                <td css={styles.rowText}>{t.checkedInCount}</td>
                <td css={styles.rowText}>{t.checkedInRate}%</td>
                <td>{t.redeemedCount}</td>
                <td css={styles.rowText}>{t.redeemedRate}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {displayTickets.length === 0 && (
        <p style={{ textAlign: "center", marginTop: "40px", color: "#666" }}>
          データが見つかりません
        </p>
      )}
    </div>
  );
};
//TODO: 仮のデザイン
const styles = {
  container: css({
    backgroundColor: "#000000",
    color: "#ffffff",
    padding: "24px",
    minHeight: "100vh",
    fontFamily: "sans-serif",
  }),
  headerText: css({
    fontSize: "1.5rem",
    fontWeight: "bold",
    marginBottom: "20px",
  }),
  tableWrapper: css({
    width: "100%",
    marginTop: "20px",
    backgroundColor: "#111111",
    borderRadius: "8px",
    overflow: "hidden",
    border: "1px solid #333",
  }),
  table: css({
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
  }),
  headerRow: css({
    backgroundColor: "#1f1f1f",
    borderBottom: "2px solid #333",
    "& th": {
      padding: "12px 16px",
      fontSize: "0.85rem",
      color: "#9ca3af",
      fontWeight: "bold",
      textAlign: "left",
    },
    // idと名前の列を広くする
    "& th:first-of-type": { width: "2fr" },
    "& th:nth-of-type(2)": { width: "2fr" },
  }),
  rowItem: css({
    borderBottom: "1px solid #222",
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: "#1a1a1a",
    },
    "& td": {
      padding: "16px",
      fontSize: "0.95rem",
      verticalAlign: "middle",
    },
  }),
  rowText: css({
    color: "#fff",
    fontSize: "0.9rem",
  }),
};
